import * as React from 'react';
const EritemaSolareIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M63.98 103.13c-1.04-60.94 24.56-27.41 27.89-54.28"
      className="prefix__cls-2"
    />
    <path
      d="M75.65 83.63c.59 9.54.61 13.96-.25 19.5M80.47 115.87c.33-2.99.35-6.01.02-9.03-.52-4.74-2.14-9.18-3.23-13.8-.89-3.75-1.44-7.58-1.8-11.42M136.02 103.13c1.04-60.94-24.56-27.41-27.89-54.28M124.24 85.43c-.48 8.31-.45 12.52.36 17.69"
      className="prefix__cls-2"
    />
    <path
      d="M119.43 115.87c-.26-3.04-.23-6.1 0-9.06 1.09-8.69 4.89-16.3 5.12-25.18"
      className="prefix__cls-2"
    />
    <path
      d="M111.06 70.19c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M84.87 74.21c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M115.53 76.9c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M103.51 75.98c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M102.18 67.63c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M94.87 75.98c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M91.92 69.13c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11"
      className="prefix__cls-1"
    />
    <circle cx={100} cy={133} r={6.62} className="prefix__cls-1" />
    <path
      d="M100 114.86v5.8M100 145.35v5.8M87.17 120.17l4.1 4.11M108.73 141.73l4.1 4.11M81.85 133h5.81M112.34 133l5.81.01M87.17 145.84l4.1-4.11M108.73 124.28l4.1-4.11"
      className="prefix__cls-1"
    />
  </svg>
);
export default EritemaSolareIcon;
